import { Button } from "@/components/ui/button";
import { Download, Upload, Loader2 } from "lucide-react";
import { useFileImport } from "@/hooks/useFileImport";
import { ImportPreviewDialog } from "@/components/import-export/ImportPreviewDialog";
import { ImportResultDialog } from "@/components/import-export/ImportResultDialog";

// Reusable "Download Template" + "Import from Excel" pair used on every master list.
export function ImportExportButtons({ entity, label = "records", facility, onImported, allowUpsert = true, className = "" }) {
  const {
    inputRef, busy, result, setResult, upsert, setUpsert, preview, committing,
    downloadTemplate, onFile, confirmImport, closePreview, downloadErrorReport,
  } = useFileImport({ entity, label, facility, onImported, allowUpsert });

  return (
    <>
      <input ref={inputRef} type="file" accept=".xlsx" className="hidden" onChange={onFile} data-testid={`import-input-${entity}`} />
      <div className={`inline-flex items-center gap-1.5 ${className}`}>
        {allowUpsert && (
          <label className="inline-flex items-center gap-1 text-[10px] text-slate-500 cursor-pointer mr-0.5" title="When on, matching rows update the existing record instead of being skipped" data-testid={`upsert-toggle-${entity}`}>
            <input type="checkbox" checked={upsert} onChange={(e) => setUpsert(e.target.checked)} className="h-3 w-3 accent-blue-600" data-testid={`upsert-checkbox-${entity}`} />
            Update existing
          </label>
        )}
        <Button size="sm" variant="outline" className="h-7 text-[11px]" onClick={downloadTemplate} data-testid={`template-btn-${entity}`}>
          <Download className="h-3 w-3 mr-1" /> Template
        </Button>
        <Button size="sm" variant="outline" className="h-7 text-[11px]" disabled={busy} onClick={() => inputRef.current?.click()} data-testid={`import-btn-${entity}`}>
          {busy ? <Loader2 className="h-3 w-3 mr-1 animate-spin" /> : <Upload className="h-3 w-3 mr-1" />} Import
        </Button>
      </div>

      <ImportPreviewDialog entity={entity} preview={preview} committing={committing} onCancel={closePreview} onConfirm={confirmImport} />
      <ImportResultDialog entity={entity} result={result} onClose={() => setResult(null)} onDownloadErrors={downloadErrorReport} />
    </>
  );
}
